(function () {
  var SCROLL_THRESHOLD = 60;

  function setAnnouncementHeight() {
    var bar = document.querySelector('.announcement-bar-section');
    var height = bar ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--vny-announcement-height', height + 'px');
  }

  function initVnyHeaderOverlay() {
    var header = document.querySelector('.header-wrapper.vny-header--overlay');
    if (!header) return;

    var ticking = false;

    function update() {
      var scrolled = window.scrollY > SCROLL_THRESHOLD;
      header.classList.toggle('vny-header--scrolled', scrolled);
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function init() {
    setAnnouncementHeight();
    initVnyHeaderOverlay();
    window.addEventListener('resize', setAnnouncementHeight);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
